/**
 * Wide enough to carry the shape of a statement — the tables and the projected
 * columns — without letting one row set the width of the whole table.
 */
const SQL_PREVIEW_MAX_LENGTH = 96;
const ELLIPSIS = "…";

/** Enough hex to be unique across a window without wrapping a table column. */
const SHORT_FINGERPRINT_LENGTH = 12;

/**
 * The normalized template on one line.
 *
 * `sqlPreview` arrives already normalized — it is the template the fingerprint
 * was taken over, never a truncation of an executed statement — so the only work
 * left is fitting it in a cell. Newlines and runs of indentation collapse to
 * single spaces; the untruncated form belongs on a `title`.
 *
 * An empty result means the template itself was blank, which is a bug upstream
 * rather than something to pad into a plausible-looking cell.
 */
export function formatSqlPreview(
  sqlPreview: string,
  maxLength: number = SQL_PREVIEW_MAX_LENGTH,
): string {
  const collapsed = sqlPreview.replace(/\s+/g, " ").trim();
  if (collapsed.length <= maxLength) return collapsed;
  return `${collapsed.slice(0, maxLength - ELLIPSIS.length)}${ELLIPSIS}`;
}

export function shortFingerprint(sqlFingerprint: string): string {
  return sqlFingerprint.slice(0, SHORT_FINGERPRINT_LENGTH);
}
